import { BoldReportComponents } from './core';
// tslint:disable-next-line:max-line-length

import { EventEmitter, IterableDiffers, KeyValueDiffers, Component, ElementRef, ChangeDetectorRef, Input, Output } from '@angular/core';
export class BoldReportDesignerComponent extends BoldReportComponents<any, any> {
	 configurePaneSettings_input: any;
	 locale_input: any;
	 permissionSettings_input: any;
	 previewOptions_input: any;
	 reportDataExtensions_input: any;
	 reportItemExtensions_input: any;
	 reportPath_input: any;
	 reportType_input: any;
	 reportServerUrl_input: any;
	 serviceAuthorizationToken_input: any;
	 serviceUrl_input: any;
	 tenantName_input: any;
	 toolbarSettings_input: any;
	 waitingPopupTemplate_input: any;
	 configurePaneSettings_items_input: any;
	 configurePaneSettings_showPane_input: any;
	 dataSources_name_input: any;
	 dataSources_value_input: any;
	 exportSettings_exportOptions_input: any;
	 exportSettings_excelFormat_input: any;
	 exportSettings_wordFormat_input: any;
	 exportSettings_customItems_input: any;
	 pageSettings_orientation_input: any;
	 pageSettings_paperSize_input: any;
	 pageSettings_height_input: any;
	 pageSettings_width_input: any;
	 pageSettings_margins_input: any;
	 parameters_labels_input: any;
	 parameters_name_input: any;
	 parameters_nullable_input: any;
	 parameters_prompt_input: any;
	 parameters_values_input: any;
	 parameterSettings_delimiterChar_input: any;
	 parameterSettings_popupHeight_input: any;
	 parameterSettings_popupWidth_input: any;
	 parameterSettings_itemWidth_input: any;
	 parameterSettings_labelWidth_input: any;
	 permissionSettings_dataSet_input: any;
	 permissionSettings_dataSource_input: any;
	 previewOptions_dataSources_input: any;
	 previewOptions_enableParameterBlockScroller_input: any;
	 previewOptions_enableDatasourceBlockScroller_input: any;
	 previewOptions_enableDropDownSearch_input: any;
	 previewOptions_exportSettings_input: any;
	 previewOptions_pageSettings_input: any;
	 previewOptions_parameters_input: any;
	 previewOptions_parameterSettings_input: any;
	 previewOptions_printMode_input: any;
	 previewOptions_printOption_input: any;
	 previewOptions_toolbarSettings_input: any;
	 previewOptions_zoomFactor_input: any;
	 reportDataExtensions_name_input: any;
	 reportDataExtensions_className_input: any;
	 reportDataExtensions_imageClass_input: any;
	 reportDataExtensions_displayName_input: any;
	 reportItemExtensions_name_input: any;
	 reportItemExtensions_className_input: any;
	 reportItemExtensions_imageClass_input: any;
	 reportItemExtensions_displayName_input: any;
	 reportItemExtensions_category_input: any;
	 reportItemExtensions_toolTip_input: any;
	 toolbarSettings_items_input: any;
	 toolbarSettings_showToolbar_input: any;
	 toolbarSettings_templateId_input: any;


	 ajaxBeforeLoad_output : any = new EventEmitter();
	 ajaxError_output : any = new EventEmitter();
	 ajaxSuccess_output : any = new EventEmitter();
	 create_output : any = new EventEmitter();
	 destroy_output : any = new EventEmitter();
	 newDataClick_output : any = new EventEmitter();
	 openReportClick_output : any = new EventEmitter();
	 previewReport_output : any = new EventEmitter();
	 reportModified_output : any = new EventEmitter();
	 reportOpened_output : any = new EventEmitter();
	 reportSaved_output : any = new EventEmitter();
	 saveReportClick_output : any = new EventEmitter();
	 toolbarClick_output : any = new EventEmitter();
	 toolbarRendering_output : any = new EventEmitter();
/**
 * @param {?} el
 * @param {?} cdRef
 * @param {?} _ejIterableDiffers
 * @param {?} _ejkeyvaluediffers
 */
constructor(public el: ElementRef,
public cdRef: ChangeDetectorRef,
private _ejIterableDiffers: IterableDiffers,
private _ejkeyvaluediffers: KeyValueDiffers) {
        super('BoldReportDesigner', el, cdRef, [], _ejIterableDiffers, _ejkeyvaluediffers);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'bold-reportdesigner',
    template: ''}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ChangeDetectorRef, },
{type: IterableDiffers, },
{type: KeyValueDiffers, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'configurePaneSettings_input': [{ type: Input, args: ['configurePaneSettings', ] },],
'locale_input': [{ type: Input, args: ['locale', ] },],
'permissionSettings_input': [{ type: Input, args: ['permissionSettings', ] },],
'previewOptions_input': [{ type: Input, args: ['previewOptions', ] },],
'reportDataExtensions_input': [{ type: Input, args: ['reportDataExtensions', ] },],
'reportItemExtensions_input': [{ type: Input, args: ['reportItemExtensions', ] },],
'reportPath_input': [{ type: Input, args: ['reportPath', ] },],
'reportType_input': [{ type: Input, args: ['reportType', ] },],
'reportServerUrl_input': [{ type: Input, args: ['reportServerUrl', ] },],
'serviceAuthorizationToken_input': [{ type: Input, args: ['serviceAuthorizationToken', ] },],
'serviceUrl_input': [{ type: Input, args: ['serviceUrl', ] },],
'tenantName_input': [{ type: Input, args: ['tenantName', ] },],
'toolbarSettings_input': [{ type: Input, args: ['toolbarSettings', ] },],
'waitingPopupTemplate_input': [{ type: Input, args: ['waitingPopupTemplate', ] },],
'configurePaneSettings_items_input': [{ type: Input, args: ['configurePaneSettings.items', ] },],
'configurePaneSettings_showPane_input': [{ type: Input, args: ['configurePaneSettings.showPane', ] },],
'dataSources_name_input': [{ type: Input, args: ['dataSources.name', ] },],
'dataSources_value_input': [{ type: Input, args: ['dataSources.value', ] },],
'exportSettings_exportOptions_input': [{ type: Input, args: ['exportSettings.exportOptions', ] },],
'exportSettings_excelFormat_input': [{ type: Input, args: ['exportSettings.excelFormat', ] },],
'exportSettings_wordFormat_input': [{ type: Input, args: ['exportSettings.wordFormat', ] },],
'exportSettings_customItems_input': [{ type: Input, args: ['exportSettings.customItems', ] },],
'pageSettings_orientation_input': [{ type: Input, args: ['pageSettings.orientation', ] },],
'pageSettings_paperSize_input': [{ type: Input, args: ['pageSettings.paperSize', ] },],
'pageSettings_height_input': [{ type: Input, args: ['pageSettings.height', ] },],
'pageSettings_width_input': [{ type: Input, args: ['pageSettings.width', ] },],
'pageSettings_margins_input': [{ type: Input, args: ['pageSettings.margins', ] },],
'parameters_labels_input': [{ type: Input, args: ['parameters.labels', ] },],
'parameters_name_input': [{ type: Input, args: ['parameters.name', ] },],
'parameters_nullable_input': [{ type: Input, args: ['parameters.nullable', ] },],
'parameters_prompt_input': [{ type: Input, args: ['parameters.prompt', ] },],
'parameters_values_input': [{ type: Input, args: ['parameters.values', ] },],
'parameterSettings_delimiterChar_input': [{ type: Input, args: ['parameterSettings.delimiterChar', ] },],
'parameterSettings_popupHeight_input': [{ type: Input, args: ['parameterSettings.popupHeight', ] },],
'parameterSettings_popupWidth_input': [{ type: Input, args: ['parameterSettings.popupWidth', ] },],
'parameterSettings_itemWidth_input': [{ type: Input, args: ['parameterSettings.itemWidth', ] },],
'parameterSettings_labelWidth_input': [{ type: Input, args: ['parameterSettings.labelWidth', ] },],
'permissionSettings_dataSet_input': [{ type: Input, args: ['permissionSettings.dataSet', ] },],
'permissionSettings_dataSource_input': [{ type: Input, args: ['permissionSettings.dataSource', ] },],
'previewOptions_dataSources_input': [{ type: Input, args: ['previewOptions.dataSources', ] },],
'previewOptions_enableParameterBlockScroller_input': [{ type: Input, args: ['previewOptions.enableParameterBlockScroller', ] },],
'previewOptions_enableDatasourceBlockScroller_input': [{ type: Input, args: ['previewOptions.enableDatasourceBlockScroller', ] },],
'previewOptions_enableDropDownSearch_input': [{ type: Input, args: ['previewOptions.enableDropDownSearch', ] },],
'previewOptions_exportSettings_input': [{ type: Input, args: ['previewOptions.exportSettings', ] },],
'previewOptions_pageSettings_input': [{ type: Input, args: ['previewOptions.pageSettings', ] },],
'previewOptions_parameters_input': [{ type: Input, args: ['previewOptions.parameters', ] },],
'previewOptions_parameterSettings_input': [{ type: Input, args: ['previewOptions.parameterSettings', ] },],
'previewOptions_printMode_input': [{ type: Input, args: ['previewOptions.printMode', ] },],
'previewOptions_printOption_input': [{ type: Input, args: ['previewOptions.printOption', ] },],
'previewOptions_toolbarSettings_input': [{ type: Input, args: ['previewOptions.toolbarSettings', ] },],
'previewOptions_zoomFactor_input': [{ type: Input, args: ['previewOptions.zoomFactor', ] },],
'reportDataExtensions_name_input': [{ type: Input, args: ['reportDataExtensions.name', ] },],
'reportDataExtensions_className_input': [{ type: Input, args: ['reportDataExtensions.className', ] },],
'reportDataExtensions_imageClass_input': [{ type: Input, args: ['reportDataExtensions.imageClass', ] },],
'reportDataExtensions_displayName_input': [{ type: Input, args: ['reportDataExtensions.displayName', ] },],
'reportItemExtensions_name_input': [{ type: Input, args: ['reportItemExtensions.name', ] },],
'reportItemExtensions_className_input': [{ type: Input, args: ['reportItemExtensions.className', ] },],
'reportItemExtensions_imageClass_input': [{ type: Input, args: ['reportItemExtensions.imageClass', ] },],
'reportItemExtensions_displayName_input': [{ type: Input, args: ['reportItemExtensions.displayName', ] },],
'reportItemExtensions_category_input': [{ type: Input, args: ['reportItemExtensions.category', ] },],
'reportItemExtensions_toolTip_input': [{ type: Input, args: ['reportItemExtensions.toolTip', ] },],
'toolbarSettings_items_input': [{ type: Input, args: ['toolbarSettings.items', ] },],
'toolbarSettings_showToolbar_input': [{ type: Input, args: ['toolbarSettings.showToolbar', ] },],
'toolbarSettings_templateId_input': [{ type: Input, args: ['toolbarSettings.templateId', ] },],
'ajaxBeforeLoad_output': [{ type: Output, args: ['ajaxBeforeLoad', ] },],
'ajaxError_output': [{ type: Output, args: ['ajaxError', ] },],
'ajaxSuccess_output': [{ type: Output, args: ['ajaxSuccess', ] },],
'create_output': [{ type: Output, args: ['create', ] },],
'destroy_output': [{ type: Output, args: ['destroy', ] },],
'newDataClick_output': [{ type: Output, args: ['newDataClick', ] },],
'openReportClick_output': [{ type: Output, args: ['openReportClick', ] },],
'previewReport_output': [{ type: Output, args: ['previewReport', ] },],
'reportModified_output': [{ type: Output, args: ['reportModified', ] },],
'reportOpened_output': [{ type: Output, args: ['reportOpened', ] },],
'reportSaved_output': [{ type: Output, args: ['reportSaved', ] },],
'saveReportClick_output': [{ type: Output, args: ['saveReportClick', ] },],
'toolbarClick_output': [{ type: Output, args: ['toolbarClick', ] },],
'toolbarRendering_output': [{ type: Output, args: ['toolbarRendering', ] },],
};
}

function BoldReportDesignerComponent_tsickle_Closure_declarations() {
/** @type {?} */
BoldReportDesignerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoldReportDesignerComponent.ctorParameters;
/** @type {?} */
BoldReportDesignerComponent.propDecorators;
/** @type {?} */
BoldReportDesignerComponent.prototype.configurePaneSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.locale_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.permissionSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportDataExtensions_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportPath_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportType_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportServerUrl_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.serviceAuthorizationToken_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.serviceUrl_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.tenantName_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.toolbarSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.waitingPopupTemplate_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.configurePaneSettings_items_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.configurePaneSettings_showPane_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.dataSources_name_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.dataSources_value_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.exportSettings_exportOptions_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.exportSettings_excelFormat_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.exportSettings_wordFormat_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.exportSettings_customItems_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.pageSettings_orientation_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.pageSettings_paperSize_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.pageSettings_height_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.pageSettings_width_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.pageSettings_margins_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameters_labels_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameters_name_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameters_nullable_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameters_prompt_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameters_values_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameterSettings_delimiterChar_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameterSettings_popupHeight_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameterSettings_popupWidth_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameterSettings_itemWidth_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.parameterSettings_labelWidth_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.permissionSettings_dataSet_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.permissionSettings_dataSource_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_dataSources_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_enableParameterBlockScroller_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_enableDatasourceBlockScroller_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_enableDropDownSearch_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_exportSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_pageSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_parameters_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_parameterSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_printMode_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_printOption_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_toolbarSettings_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewOptions_zoomFactor_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportDataExtensions_name_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportDataExtensions_className_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportDataExtensions_imageClass_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportDataExtensions_displayName_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_name_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_className_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_imageClass_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_displayName_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_category_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportItemExtensions_toolTip_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.toolbarSettings_items_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.toolbarSettings_showToolbar_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.toolbarSettings_templateId_input;
/** @type {?} */
BoldReportDesignerComponent.prototype.ajaxBeforeLoad_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.ajaxError_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.ajaxSuccess_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.create_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.destroy_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.newDataClick_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.openReportClick_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.previewReport_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportModified_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportOpened_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.reportSaved_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.saveReportClick_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.toolbarClick_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.toolbarRendering_output;
/** @type {?} */
BoldReportDesignerComponent.prototype.el;
/** @type {?} */
BoldReportDesignerComponent.prototype.cdRef;
/** @type {?} */
BoldReportDesignerComponent.prototype._ejIterableDiffers;
/** @type {?} */
BoldReportDesignerComponent.prototype._ejkeyvaluediffers;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
